import { render, staticRenderFns } from "./SDASuccessResult.vue?vue&type=template&id=be386fa0"
import script from "./SDASuccessResult.vue?vue&type=script&lang=js"
export * from "./SDASuccessResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports